export default __webpack_public_path__ + "static/media/calendar.27659956.png";